import { useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Carousel, Flex } from "antd";
import Millionpage from "../../assets/Million_Data.png";
import PositiveImage from "../../assets/Positive_Feedback.png";
import Qualified from "../../assets/Qualified_Enumerator.png";
import Successful from "../../assets/Sucessful.png";

const AnimatedNumber = ({ value, steps, isActive }:any) => {
    const { number } = useSpring({
        from: { number: 0 },
        to: { number: isActive ? value : 0 },
        delay: 60,
        config: { duration: 1500 },
    });

    return (
        <animated.span>
            {number.to((n) => {
                for (let i = steps.length - 1; i >= 0; i--) {
                    if (n >= steps[i]) return steps[i];
                }
                return 0;
            })}
        </animated.span>
    );
};

const NumberCard = () => {
    const isMobile = window.innerWidth <= 768;
    const [currentSlide, setCurrentSlide] = useState(0);

    return (
        <div className="flex flex-col space-y-10 h-auto my-15 md:mb-10 " >
            <div className="flex flex-col items-center space-y-5 mx-5 mb-10 text-center">
                <h1 className="font-extrabold text-3xl md:text-6xl">
                    By the Numbers:
                    <span className="text-primary font-black"> Our Impact and Reach</span>
                </h1>
                <p className="font-normal text-base md:text-lg text-border leading-5">
                    Explore the key metrics that make HireEnumerators.com the go-to platform for both recruiters and skilled enumerators.
                </p>
            </div>

            <div className="w-full md:max-w-6xl mx-auto  md:px-0 bg-[#dcfce7]">
            <Carousel
                effect="fade"
                autoplay
                autoplaySpeed={3500}
                beforeChange={(prev, next) => setCurrentSlide(next)}
            >
                <div>
                    <Flex vertical={isMobile}>
                        <div className={isMobile ? "w-full" : "w-[55%]"}>
                            <img alt="#" src={Successful} className="w-full" />
                        </div>
                        <div className={isMobile ? "w-full px-6 py-2" : "w-[45%] flex md:px-10  place-items-center"}>
                            <div className="flex flex-col self-center md:space-y-3">
                                <h1 className="font-bold md:text-5xl text-2xl mb-5 "
                                style={!isMobile ? { lineHeight: '3.5rem' } : {}}>
                                    <span className="text-primary font-black">
                                        <span className="inline-block w-auto text-left tabular-nums tracking-tighter">
                                            <AnimatedNumber value={500} steps={[100, 200, 300, 400, 500]} isActive={currentSlide === 0} />
                                        </span>+ </span> Successful Job Postings
                                </h1>
                                <p className=" font-normal md:text-2xl text-md text-border tracking-wide">
                                    We’ve connected hundreds of organizations with reliable enumerators for projects big and small.
                                </p>
                            </div>
                        </div>
                    </Flex>
                </div>

                <div>
                    <Flex vertical={isMobile}>
                        <div className={isMobile ? "w-full" : "w-[55%]"}>
                            <img alt="#" src={PositiveImage} className="w-full" />
                        </div>
                        <div className={isMobile ? "w-full px-6 py-2" : "w-[45%] flex md:ps-10 pr-6 place-items-center"}>
                            <div className="flex flex-col self-center md:space-y-3">
                                <h1 className="font-bold md:text-5xl text-2xl mb-5 "
                                style={!isMobile ? { lineHeight: '3.5rem' } : {}}>
                                    <span className="text-primary font-black">
                                        <span className="inline-block w-auto text-left tabular-nums tracking-tighter">
                                            <AnimatedNumber value={98} steps={[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 98]} isActive={currentSlide === 1} />
                                        </span>% </span>
                                    Positive Feedback
                                </h1>
                                <p className=" font-normal md:text-2xl text-md text-border tracking-wide">
                                    Both recruitors and enumerators report high satisfaction, citing streamlined processes and trusted partnerships.
                                </p>
                            </div>
                        </div>
                    </Flex>
                </div>

                <div>
                    <Flex vertical={isMobile}>
                        <div className={isMobile ? "w-full" : "w-[55%]"}>
                            <img alt="#" src={Millionpage} className="w-full" />
                        </div>
                        <div className={isMobile ? "w-full px-6 py-2" : "w-[45%] flex md:ps-10 pr-6 place-items-center "}>
                            <div className="flex flex-col self-center md:space-y-3">
                                <h1 className="font-bold md:text-5xl text-2xl mb-5 "
                                style={!isMobile ? { lineHeight: '3.5rem' } : {}}>
                                    <span className=" text-primary font-black">
                                        <span className="inline-block w-24 text-right tabular-nums tracking-tighter ">
                                            <AnimatedNumber value={1} steps={[0, 0.25, 0.55, 0.75, 1]} isActive={currentSlide === 2} />
                                        </span> Million+ </span> Data Points Collected
                                </h1>
                                <p className=" font-normal md:text-2xl text-md text-border tracking-wide">
                                    Our community has contributed to impactful research across healthcare, education, agriculture, and more.
                                </p>
                            </div>
                        </div>
                    </Flex>
                </div>

                <div>
                    <Flex vertical={isMobile}>
                        <div className={isMobile ? "w-full" : "w-[55%]"}>
                            <img alt="#" src={Qualified} className="w-full" />
                        </div>
                        <div className={isMobile ? "w-full px-6 py-2" : "w-[45%] flex md:ps-10 pr-6 place-items-center"}>
                            <div className="flex flex-col self-center md:space-y-3">
                                <h1 className="font-bold md:text-5xl text-2xl mb-5 "
                                style={!isMobile ? { lineHeight: '3.5rem' } : {}}>
                                    <span className="text-primary font-black">
                                        <span className="inline-block w-28 text-right tabular-nums tracking-tighter">
                                            <AnimatedNumber value={1000} steps={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} isActive={currentSlide === 3} />
                                        </span>+ </span>
                                    Qualified Enumerators
                                </h1>
                                <p className=" font-normal md:text-2xl text-md text-border tracking-normal">
                                    Our network spans multiple provinces, ensuring you find the right fit wherever your project is located.
                                </p>
                            </div>
                        </div>
                    </Flex>
                </div>
            </Carousel>
            </div>
            <div className="max-w-6xl border-y-4 border-green-200 mx-auto p-4 md:p-10">
                <h1 className="text-base md:text-xl font-medium text-center">
                    “ Whether you’re looking to hire top-notch enumerators or seeking new projects to showcase your skills, our numbers speak for themselves—join the growing HireEnumerators.com community today! ”
                </h1>
            </div>
        </div>
    );
};

export default NumberCard;